


























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { Getter, Action } from "vuex-class";
import * as util from "@/service/util";
import requestService from "@/service/requestService";
import { SubHeaderData } from "@/model/SubHeaderData";

@Component({
  components: {
    ConfirmDialog
  }
})
export default class IntermediateStandby extends Vue {
  activePage: number = 0;
  @Prop({ default: 1 })
  page: number;
  waitingMinute: number = 0;
  reqService: requestService;
  jizenFlg: boolean = false;

  $refs!: {
    dialog: ConfirmDialog;
    cancelDialog: ConfirmDialog;
  };

  @Getter("inspectTime", { namespace: "SubHeader" })
  inspectTime: number;

  @Getter("maintenanceExpectTime", { namespace: "SubHeader" })
  maintenanceExpectTime: number;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;

  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;

  @Getter("stateId", { namespace: "SubHeader" })
  stateId: number;

  /** 2021-09-10 sh #7396 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [START] */
  @Getter("isCanJizenMitsumori", { namespace: "FunctionSetting"} )
  isCanJizenMitsumori: any;
  @Getter("isDoJizen", { namespace: "InspectionDetail" })
  isDoJizen: boolean;
  /** 2021-09-10 sh #7396 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [END] */

  // timerCheckPayment: any = null;
  created() {
    this.reqService = new requestService();
    this.getSubHeaderData();
    // this.timerCheckPayment = setInterval(() => {
    //   this.reqService.getIsConfirm(this.uketsukeExtendsId).then((res: any) => {
    //     if (res && res.isConfirmPayment) {
    //       this.clearTimeOutCheckPayment();
    //       this.$router.push({ name: "standby", params: { page: "3" } });
    //     }
    //   });
    // }, 60000);

    this.onUpdateWorkProgress();
    if (this.page == 2) {
      this.updateStatus();
    }
    this.getJizenVal();
  }

  onUpdateWorkProgress() {
    if (this.page == 2) {
      this.updateWorkProgressState("MD0009");
      setInterval(() => {
        this.waitingMinute++;
      }, 60000);
    } else if (this.page == 3) {
      this.updateWorkProgressState("MD0010");
    }
  }

  getSubHeaderData() {
    this.reqService
      .getSubHeaderData(this.uketsukeExtendsId, this.$route.meta)
      .then(
        (res: SubHeaderData) => {
          this.setProgressState({
            stateId: res.sknWorkProgressStateId,
            stateNm: res.sknWorkProgressStateNm
          });
        },
        (err: any) => {}
      );
  }

  @Watch("$route")
  onRouteChange(to: any, from: any) {
    this.onUpdateWorkProgress();
  }

  // clearTimeOutCheckPayment() {
  //   if (this.timerCheckPayment) {
  //     clearInterval(this.timerCheckPayment);
  //     this.timerCheckPayment = null;
  //   }
  // }

  onConfirmEnd() {
    this.$refs.dialog.onOpen();
  }

  onConfirm() {
    // if (this.page == 3) {
    //   this.$router.push({
    //     name: "inspectiondetail"
    //   });
    // } else {
    this.goToPage("reservation");
    // }
  }

  goToPage(pageName: string) {
    if (pageName == "partsselect") {
      this.$emit("onregister", {
        pageName: "recmaintenance",
        notCurrentActive: true
      });
    }
    this.$router.push({ name: pageName });
  }

  startMaintenance() {
    this.$emit("startMaintenance");
    this.goToPage("workorder");
  }

  updateWorkProgressState(screenCd: string) {
    const data = {
      screenCd,
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      currentWorkProgressState: this.stateId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.updateWorkProgressState(data).then(res => {
      this.getSubHeaderData();
    });
  }

  // beforeDestroy() {
  //   this.clearTimeOutCheckPayment();
  // }

  updateStatus() {
    this.reqService.getIsConfirm(this.uketsukeExtendsId).then((res: any) => {
      if (res && res.isConfirmPayment) {
        this.$router.push({ name: "standby", params: { page: "3" } });
      }
    });
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => {
      this.$router.push({ name: "reservation" });
    });
  }

  getJizenVal() {
    this.reqService.getJizenVal().then(
      (res: any) => {
        this.jizenFlg = res ? (res == '1' ? true: false): false;
      },
      (err: any) => {
      }
    );
  }
  /** 2021-09-10 sh #7396 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [START] */
  checkIsCanJizen() {
    // console.log("workOrder.checkIsCanJizen isDoJizen => ", this.isDoJizen);
    // console.log("workOrder.checkIsCanJizen isCanJizenMitsumori => ", this.isCanJizenMitsumori);
    return this.isCanJizenMitsumori && this.isDoJizen;
  }
  /** 2021-09-10 sh #7396 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [END] */
}
